module.exports = __webpack_public_path__ + "img/banner-bibliotech-new.7c10910a.png";